/** @prettier */
let landingAPISetting: null | boolean = null;

export const setShowCustomParamsUserId = (value: boolean) => {
  landingAPISetting = value;
};

export const showCustomParamsUserId = () =>
  landingAPISetting != null ? landingAPISetting : false;
